import _ from 'underscore';

export default class UserService {
  constructor($http) {
    this.$http = $http;
  }
  
  get_stocklists(user_id) {
    return this.$http({
      method: 'GET',
      url: `/admin/marketplace/users/get_stocklists/${user_id}`
    }).then(function(response) {
      return response.data;
    });
  }

  get(user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_user',
      params: {user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  search_by_company(user_type, company) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/user_company_autocomplete',
      params: {user_type: user_type, company_title: company}
    }).then(function(response) {
      return response.data;
    });
  }

  get_accounts(user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_user_accounts',
      params: {user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_contacts(user_id) {
    return this.$http.get(
      '/admin/marketplace/users/get_user_contacts_json',
      {params: {user_id: user_id}}
    );
  }

  get_demand_data(user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_demand_data',
      params: {user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_order_data(user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_order_data',
      params: {user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  get_notes(user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_user_notes',
      params: {user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  find_similar(company_data) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/find_similar',
      data: {company_data: company_data, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  create(user, account) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/save',
      data: {user: user, account: account, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  update(user, user_groups, user_business_types) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/save',
      data: {user: user, user_groups: user_groups, user_business_types: user_business_types, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  account_email_exists(email) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/account_email_exists',
      params: {email: email}
    }).then(function(response) {
      return response.data;
    });
  }

  contact_email_exists(email, user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/contact_email_exists',
      params: {email: email, user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  register_account_email_exists(email) {
    return this.$http({
      method: 'GET',
      url: '/registration/account_email_exists',
      params: {email: email}
    }).then(function(response) {
      return response.data;
    });
  }

  get_faqs(user_id, section_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_faqs',
      params: {user_id: user_id, section_id: section_id}
    }).then(function(response) {
      return response.data;
    });
  }

  save_faq(user_id, faq) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/save_faq',
      data: {user_id: user_id, faq: faq, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  mass_save_faqs(user_id, faqs, selected) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/mass_save_faqs',
      data: {user_id: user_id, faqs: faqs, selected: selected, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  save_register_data(user, account) {
    return this.$http({
      method: 'POST',
      url: '/registration/save_register_data',
      data: {user: user, account: account}
    }).then(function(response) {
      return response.data;
    });
  }

  create_from_pending(pending_registration_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/create_from_pending',
      data: {id: pending_registration_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  create_from_pending_import(pending_import_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/create_from_pending_import',
      data: {id: pending_import_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  mass_create_from_pending_imports(pending_imports) {
    return this.$http.post(
      '/admin/marketplace/users/mass_create_from_pending_imports',
      {pending_imports: pending_imports, authenticity_token: window.token}
    );
  }

  get_similar_tabs() {
    return ['All', 'High', 'Medium', 'Low'];
  }

  get_similar_dialog_tabs() {
    return ['Analysis', 'Similarity'];
  }

  get_filtered_similar_users(similar_users, index) {
    if (index === 0)
      return similar_users;
    else if (index == 1)
      return _.filter(similar_users, function(user) { return user.similarity.level == 'High';});
    else if (index == 2)
      return _.filter(similar_users, function(user) { return user.similarity.level == 'Medium';});
    else if (index == 3)
      return _.filter(similar_users, function(user) { return user.similarity.level == 'Low';});
  }

  get_filtered_users(users, index) {
    if (index === 0)
      return users;
    else if (index == 1)
      return _.filter(users, function(user) { return user.type == 'Buyer';});
    else if (index == 2)
      return _.filter(users, function(user) { return user.type == 'Seller';});
  }

  connect_users(connection) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/connect_users',
      data: {connection: connection, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  disconnect_users(connection) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/disconnect_users',
      data: {connection: connection, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  search(filters) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/search_all',
      data: {filters: filters, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  delete_custom_consignee(user_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/delete_custom_consignee',
      data: {id: user_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  delete_custom_notify(user_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/delete_custom_notify',
      data: {id: user_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  delete_custom_docs(user_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/delete_custom_docs',
      data: {id: user_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  save_custom_consignee(user_id, address) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/save_custom_consignee',
      data: {id: user_id, address: address, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  save_custom_notify(user_id, address) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/save_custom_notify',
      data: {id: user_id, address: address, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  save_custom_docs(user_id, address) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/save_custom_docs',
      data: {id: user_id, address: address, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  save_export_docs(user_id, docs) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/save_export_docs',
      data: {id: user_id, docs: docs, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_seller_trading_data(user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_seller_trading_data',
      params: {user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  save_company_common_word(common_word) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/save_company_common_word',
      data: {common_word: common_word, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_pending_imports() {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_pending_imports',
      params: {}
    }).then(function(response) {
      return response.data;
    });
  }

  delete_pending_import(pending_import_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/delete_pending_import',
      data: {pending_import_id: pending_import_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_matched_offers(user_id, filter) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/get_matched_offers',
      data: {user_id: user_id, filter: filter, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_country_charges(user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_country_charges',
      params: {user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  save_country_charges(charges) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/save_country_charges',
      data: {charges: charges, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  delete_country_charge(charge_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/delete_country_charge',
      data: {charge_id: charge_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  delete_country_charges(charges) {
    this.$http.post(
      '/admin/marketplace/users/delete_country_charges',
      {charges: charges, authenticity_token: window.token}
    );
  }

  get_incoterm_charges(user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_incoterm_charges',
      params: {user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  save_incoterm_charge(charge) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/save_incoterm_charge',
      data: {charge: charge, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  delete_incoterm_charge(charge_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/delete_incoterm_charge',
      data: {charge_id: charge_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_user_product_groups(user_id) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/get_user_product_groups',
      params: {user_id: user_id}
    }).then(function(response) {
      return response.data;
    });
  }

  update_supplier_newsletter_settings(user_id, settings) {
    return this.$http.post(
      '/admin/marketplace/users/update_supplier_newsletter_settings',
      {user_id: user_id, settings: settings, authenticity_token: window.token}
    );
  }

  get_supplier_product_pricings(user_id) {
    return this.$http.get('/admin/marketplace/users/get_supplier_product_pricings/' + user_id);
  }

  update_supplier_pricings(user_id) {
    return this.$http.post(
      '/admin/marketplace/users/update_supplier_pricings',
      {user_id: user_id, authenticity_token: window.token}
    );
  }

  get_buyer_preference_products(user_id) {
    return this.$http.post(
      '/admin/marketplace/users/get_buyer_preference_products',
      {user_id: user_id, authenticity_token: window.token}
    );
  }

  get_buyer_preference_price_groups(user_id) {
    return this.$http.post(
      '/admin/marketplace/users/get_buyer_preference_price_groups',
      {user_id: user_id, authenticity_token: window.token}
    );
  }

  save_buyer_price(mode, price) {
    return this.$http.post(
      '/admin/marketplace/users/save_buyer_price',
      {mode: mode, price: price, authenticity_token: window.token}
    );
  }

  get_buyer_prices(user_id) {
    return this.$http.get('/admin/marketplace/users/get_buyer_prices/' + user_id);
  }

  delete_buyer_product_price(price_id) {
    return this.$http.post(
      '/admin/marketplace/users/delete_buyer_product_price',
      {price_id: price_id, authenticity_token: window.token}
    );
  }

  delete_buyer_price_group_price(price_id) {
    return this.$http.post(
      '/admin/marketplace/users/delete_buyer_price_group_price',
      {price_id: price_id, authenticity_token: window.token}
    );
  }

  get_specs_statuses() {
    return [
      {id: 1, name: 'Yes (auto)'},
      {id: 0, name: 'Unknown (auto)'},
      {id: 3, name: 'Yes (manual)'},
      {id: 2, name: 'Unknown (manual)'},
      {id: 4, name: 'No (manual)'}
    ];
  }

  update_specs_statuses(user_id, reel_specs_status, sheet_specs_status, rw_cutting_specs_status) {
    return this.$http.post(
      '/admin/marketplace/users/update_specs_statuses',
      {user_id: user_id, reel_specs_status: reel_specs_status, sheet_specs_status: sheet_specs_status, rw_cutting_specs_status: rw_cutting_specs_status, authenticity_token: window.token}
    );
  }

  load_specs_statuses(user_id) {
    return this.$http.get('/admin/marketplace/users/load_specs_statuses/' + user_id);
  }
  
  
  update_matching_settings(user_id, matching_settings) {
    return this.$http.post(
      '/admin/marketplace/users/update_matching_settings',
      {user_id: user_id, matching_settings: matching_settings, authenticity_token: window.token}
    );
  }
  
  load_matching_settings(user_id) {
    return this.$http.get('/admin/marketplace/users/load_matching_settings/' + user_id);
  }

  update_campaign_settings(user_id, campaign_settings) {
    return this.$http.post(
      '/admin/marketplace/users/update_campaign_settings',
      {user_id: user_id, campaign_settings: campaign_settings, authenticity_token: window.token}
    );
  }
  
  load_campaign_settings(user_id) {
    return this.$http.get('/admin/marketplace/users/load_campaign_settings/' + user_id);
  }

  get_user_types() {
    return [
      {id: 'buyer', title: 'Buyer'},
      {id: 'seller', title: 'Seller'},
    ];
  }

  get_overview_data(user_id) {
    return this.$http.get(`/admin/marketplace/users/get_overview_data/${user_id}`);
  }
}

UserService.$inject = ['$http'];



// WEBPACK FOOTER //
// ./front/js/admin/services/user.service.js